export default {
  'pages.setting.dict.title': 'Dictionary Management',
  'pages.setting.dict.subtitle': 'Organize and manage company dictionaries',
  // Left - Dictionary Types
  'pages.setting.dict.typeTitle': 'Dictionary Types',
  'pages.setting.dict.typeSearchPlaceholder': 'Search dictionary type...',
  'pages.setting.dict.typeName': 'Type Name',
  'pages.setting.dict.typeCode': 'Type Code',
  // Right - Dictionary Item Columns
  'pages.setting.dict.column.label': 'Label',
  'pages.setting.dict.column.value': 'Value',
  'pages.setting.dict.column.sort': 'Sort',
  'pages.setting.dict.column.status': 'Status',
  'pages.setting.dict.column.operation': 'Operation',
  // Status
  'pages.setting.dict.status.enabled': 'Enabled',
  'pages.setting.dict.status.disabled': 'Disabled',
  // Actions
  'pages.setting.dict.addType': 'Add Dict Type',
  'pages.setting.dict.addItem': 'Add Dict Item',
  'pages.setting.dict.edit': 'Edit',
  // Modal titles
  'pages.setting.dict.modal.addTypeTitle': 'Add Dictionary Type',
  'pages.setting.dict.modal.editTypeTitle': 'Edit Dictionary Type',
  'pages.setting.dict.modal.addItemTitle': 'Add Dictionary Item',
  'pages.setting.dict.modal.editItemTitle': 'Edit Dictionary Item',
  // Dict Type form
  'pages.setting.dict.form.dictName': 'Type Name',
  'pages.setting.dict.form.dictNamePlaceholder': 'Please enter type name',
  'pages.setting.dict.form.dictNameRequired': 'Please enter type name',
  'pages.setting.dict.form.dictType': 'Type Code',
  'pages.setting.dict.form.dictTypePlaceholder': 'Please enter type code',
  'pages.setting.dict.form.dictTypeRequired': 'Please enter type code',
  'pages.setting.dict.form.dictTypePattern': 'Type code can only contain letters, numbers and underscores',
  'pages.setting.dict.form.status': 'Status',
  'pages.setting.dict.form.statusRequired': 'Please select status',
  'pages.setting.dict.form.remark': 'Remark',
  'pages.setting.dict.form.remarkPlaceholder': 'Please enter remark',
  // Dict Item form
  'pages.setting.dict.form.dictLabel': 'Display Name',
  'pages.setting.dict.form.dictLabelPlaceholder': 'Please enter display name',
  'pages.setting.dict.form.dictLabelRequired': 'Please enter display name',
  'pages.setting.dict.form.dictValue': 'Data Value',
  'pages.setting.dict.form.dictValuePlaceholder': 'Please enter data value',
  'pages.setting.dict.form.dictValueRequired': 'Please enter data value',
  'pages.setting.dict.form.dictSort': 'Sort Order',
  'pages.setting.dict.form.dictSortPlaceholder': 'Please enter sort order',
  'pages.setting.dict.form.description': 'Description',
  'pages.setting.dict.form.descriptionPlaceholder': 'Please enter description',
  // Messages
  'pages.setting.dict.message.deleteSuccess': 'Deleted successfully',
  'pages.setting.dict.message.addSuccess': 'Added successfully',
  'pages.setting.dict.message.addFailed': 'Failed to add',
  'pages.setting.dict.message.editSuccess': 'Updated successfully',
  'pages.setting.dict.message.editFailed': 'Failed to update',
};
